import {IAttributes, IAugmentedJQuery, IDirective, IScope} from "angular";
import _ from "lodash";

export function escKeyForInjisering() {
        return [escKey];
    }

    export const escKey_event = 'escKey.event';

    /** Lar deg registrere en metode som blir kalt når bruker trykker på esc tasten */
    export function escKey(): IDirective {
        const ESCAPE_KEY = 27;
        return {
            restrict: 'A',
            link: ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) => {
                $element.bind('keydown keypress', (event) => {
                    if (event.which !== ESCAPE_KEY) return;

                    $scope.$apply(() => {
                        if (!_.isEmpty($attr['escKey']))
                            $scope.$eval($attr['escKey']);
                        $scope.$root.$broadcast(escKey_event);
                    });
                });
            }
        }
    }

